var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 40,
    viewBox: "0 0 45 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.9219 20C44.9219 21.4062 43.75 22.5 42.4219 22.5H39.9219L40 35C40 35.2344 40 35.4688 40 35.625V36.875C40 38.6719 38.5938 40 36.875 40H35.625C35.4688 40 35.3906 40 35.3125 40C35.2344 40 35.0781 40 35 40H32.5H30.625C28.8281 40 27.5 38.6719 27.5 36.875V35V30C27.5 28.6719 26.3281 27.5 25 27.5H20C18.5938 27.5 17.5 28.6719 17.5 30V35V36.875C17.5 38.6719 16.0938 40 14.375 40H12.5H10C9.84375 40 9.76562 40 9.60938 40C9.53125 40 9.45312 40 9.375 40H8.125C6.32812 40 5 38.6719 5 36.875V28.125C5 28.125 5 28.0469 5 27.9688V22.5H2.5C1.09375 22.5 0 21.4062 0 20C0 19.2969 0.234375 18.6719 0.78125 18.125L20.7812 0.625C21.3281 0.078125 21.9531 0 22.5 0C23.0469 0 23.6719 0.15625 24.1406 0.546875L44.0625 18.125C44.6875 18.6719 45 19.2969 44.9219 20Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.6977927cf5c7868c422e921b490220ac.svg";
export { ForwardRef as ReactComponent };